/**
 * Available contexts for login modal
 */
type LoginModalContext = 'default' | 'favorites';

/**
 * Options for opening login modal
 */
interface LoginModalOptions {
	context?: LoginModalContext;
}

/**
 * Internal modal state structure
 */
interface LoginModalState {
	isOpen: boolean;
	context: LoginModalContext;
}

/**
 * Global composable for managing login modal state
 */
export function useLoginModal() {
	const modalState = useState<LoginModalState>('login-modal', () => ({
		isOpen: false,
		context: 'default'
	}));

	/**
	 * Opens the login modal with optional context
	 * @param options - Configuration options for modal opening
	 */
	function openLoginModal(options: LoginModalOptions = {}): void {
		modalState.value.context = options.context ?? 'default';
		modalState.value.isOpen = true;
	}

	/**
	 * Closes the login modal and resets context to default
	 */
	function closeLoginModal(): void {
		modalState.value.isOpen = false;
		modalState.value.context = 'default';
	}

	return {
		modalState: readonly(modalState),
		openLoginModal,
		closeLoginModal
	};
}
